import { FAQ_SECTION_FRAGMENT } from './component-fragments';

export const NEWS_CATEGORIES = `
  query newsCategories {
    categories: newsCategories {
      name,
      title,
      slug,
      seo {
        title,
        description
      }
    }
  }
`;

export const PAGINATED_NEWS_QUERY = `
  query paginatedNews($skip: Int = 0, $first: Int = 30, $articleCoverWidth: Int = 340, $articleCoverHeight: Int = 224) {
    total: newsConnection {
      aggregate {
        count
      }
    },
    news: news(orderBy: published_DESC, skip: $skip, first: $first) {
      id,
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: {
                resize: {
                  width: $articleCoverWidth,
                  height: $articleCoverHeight,
                  fit: clip
                }
              }
              document: {
                output: { format: jpg }
              }
            }
          )
        }
        imageAlt
      }
    }
  }
`;

export const PAGINATED_NEWS_QUERY_BY_CATEGORY = `
  query paginatedNews($skip: Int = 0, $first: Int = 30, $slugCategory: String!, $articleCoverWidth: Int = 340, $articleCoverHeight: Int = 224){
    total: newsConnection(where:{newsCategory: {
      slug: $slugCategory,
    }} ) {
      aggregate {
        count
      }
    },
    news(orderBy: published_DESC, skip: $skip, first: $first, where:{newsCategory: {
      slug: $slugCategory,
    }}) {
      id,
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: {
                resize: {
                  width: $articleCoverWidth,
                  height: $articleCoverHeight,
                  fit: clip
                }
              }
              document: {
                output: { format: jpg }
              }
            }
          )
        }
        imageAlt
      }
    }
  }
`;

export const NEWS_QUERY = `
  query singleNews($id: ID!, $metaPreviewWidth: Int = 1200 , $metaPreviewHeight: Int = 960) {
    new(where: { id: $id }) {
      id
      category
      updatedAt
      createdAt
      published
      title
      alternateTitle
      newsCategory {
        name
        slug
      }
      imageBlock {
        image {
          url
          height
          width
        }
        imageAlt
      }
      metaPreview: imageBlock {
        image {
          url(
            transformation: {
              image: {
                resize: {
                   width: $metaPreviewWidth,
                   height: $metaPreviewHeight,
                   fit: crop
                }
              }
              document: {
                output: { format: jpg }
              }
            }
          )
        }
      }
      abstract
      introduction
      seo {
        title
        description
        keywords
      }
      mainColumn {
        __typename
        ... on AdvFluid {
          id
          advFluidType
          variant
        }
        ... on ArticleBlock {
          id
          title
          alternativeTitle
          content
          headingTitleImportance
        }
        ... on SavingCalculator {
          id
          savingCalculatorType
          title
          description
          priceLabel
          claim
          cta
        }
        ... on EvaluationLeadWizard {
          id
          title
          description
        }
      }
      blocks {
        title
        content
      }
      faq {
        ...FaqSectionComponentFields
      }
      localities {
        name
        slug
        evaluation {
          id
        }
      }
      rightColumn {
        __typename
        ... on AdvFluid {
          advFluidType
          variant
        }
      }
    }
  }
  ${FAQ_SECTION_FRAGMENT}
`;

export const RELATED_NEWS_QUERY = `
  query relatedNews($skipId: ID, $date:Date, $createdAt: DateTime, $count: Int = 4) {
    older: news(first: $count, where: { id_not: $skipId, published_lte: $date, createdAt_lt: $createdAt }, orderBy: published_DESC) {
      id,
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: { resize: { width: 90, height: 60, fit: crop } }
              document: { output: { format: jpg } }
            }
          )
        }
        imageAlt
      }
    }
    newer: news(first: $count, where: { id_not: $skipId, published_gte: $date, createdAt_gt: $createdAt}  , orderBy: published_ASC) {
      id,
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: { resize: { width: 90, height: 60, fit: crop } }
              document: { output: { format: jpg } }
            }
          )
        }
        imageAlt
      }
    }
  }
`;

export const RELATED_NEWS_BY_LOCALITY_QUERY = `
  query relatedNewsByLocality($locality: String!, $skipId: ID, $first: Int = 4, $articleCoverWidth: Int = 340, $articleCoverHeight: Int = 224) {
    news(orderBy: published_DESC, where: {localities_some: {slug: $locality}, id_not: $skipId}, first: $first) {
      id
      published
      title
      alternateTitle
      abstract
      imageBlock {
        image {
          url(
            transformation: {
              image: {
                resize: {
                  width: $articleCoverWidth,
                  height: $articleCoverHeight,
                  fit: clip
                }
              }
              document: {
                output: { format: jpg }
              }
            }
          )
        }
        imageAlt
      }
    }
  }
`;
